<template>
    <div :class="[isPC ? 'bg-pc' : 'bg']">
        <div class="content">
            <div class="info-wrapper" id="info">
                <div class="logo-wrapper">
                    <img
                        class="logo"
                        src="../assets/image/toshiba/logo@3x.png"
                    />
                    <div id="app-introduce">{{ pageInfo.introduce }}</div>
                </div>
            </div>
            <div class="footer">
                <div class="download-wrapper">
                    <p class="remind-text">
                        {{ pageInfo.remind }}
                    </p>
                    <div class="app-download" @click="clickDownload">
                        <img
                            src="../assets/image/toshiba/icon_dl@3x.png"
                            alt=""
                            class="download-icon"
                        />
                        {{ pageInfo.download }}
                    </div>
                    <div class="select-div">
                        <img
                            v-if="['ar', 'he'].includes(lang)"
                            class="select-img-left"
                            src="../assets/image/toshiba/download_ic_more_rtl@2x.png"
                        />
                        <span
                            class="select-language"
                            @click="clickSelectLang"
                            >{{ languageName }}</span
                        >
                        <img
                            v-if="!['ar', 'he'].includes(lang)"
                            class="select-img-right"
                            src="../assets/image/toshiba/download_ic_more@2x.png"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import langObj from '../language/language';
import languageMap from '../language/languageNameMap';
import IosSelect from '../assets/js/iosSelect';
import VConsole from 'vconsole';
import axios from 'axios';
import { toApp } from '@/utils/util';
// import MobileDetect from 'mobile-detect'
// import { getQueryString } from '../utils/util'
export default {
    name: 'App',
    components: {},
    data() {
        return {
            androidMarketAppLink:
                'market://details?id=com.midea.ai.toshiba.oversea.inhouse',
            androindLink:
                'https://play.google.com/store/apps/details?id=com.midea.ai.toshiba.oversea.inhouse',
            iosLink: 'https://itunes.apple.com/app/id1535414457',
            pullUpAppUrl: '',
            // lang_flag: 0,
            href: '',
            appInfo: {},
            msgJson: {},
            lang: '' // 当前页面的语言
        };
    },
    created() {
        this.initMsgJson();
        this.enterBurialPoint();
        this.init();
    },
    computed: {
        pageInfo() {
            const str = JSON.stringify(langObj[this.lang]).replace(
                /SmartHome/g,
                'TSmartLife'
            );
            return JSON.parse(str);
        },
        languageName() {
            return languageMap[this.lang];
        },
        isAndroid() {
            const ua = navigator.userAgent.toLowerCase();
            if (/iphone/.test(ua)) {
                return false;
            } else {
                return true;
            }
        },
        isPC() {
            const ua = navigator.userAgent.toLowerCase();
            if (/iphone|android/i.test(ua)) {
                return false;
            } else {
                return true;
            }
        },
        env() {
            if (
                location.href.match('sit') ||
                location.href.match('172.31.87') ||
                location.href.match('localhost')
            ) {
                return 'sit';
            } else {
                return 'prod';
            }
        }
    },
    methods: {
        init() {
            document.title = 'TSmartLife';
            // 进入页面先直接跳转
            if (this.env === 'sit') {
                /* eslint-disable no-new */
                new VConsole();
                console.log(navigator.userAgent);
            }
            console.log('isAndroid', this.isAndroid);
            console.log('isPC', this.isPC);
            this.setLangFlag();
            // this.lang_flag = 1;
            // this.setLanguage(this.lang_flag);

            /** UC浏览器和微信浏览器中，若立即跳转，则会出现UI问题：document节点的fontSize没有被设置成功 */
            setTimeout(() => {
                this.download();
            }, 100);
        },
        initMsgJson() {
            const channel =
                this.getQueryVariable('c', window.location.href) ||
                this.getQueryVariable('channel', window.location.href) ||
                '';
            const markkey =
                this.getQueryVariable('m', window.location.href) ||
                this.getQueryVariable('markkey', window.location.href) ||
                '';
            const fromkey =
                this.getQueryVariable('f', window.location.href) ||
                this.getQueryVariable('fromkey', window.location.href) ||
                '';
            const msgJson = {
                action_type: 'toshibaha', // #事件类型
                page_name: 'downloadPage', // #页面名称
                sub_action: 'page_view', // #事件动作
                action_result: '', // #额外上报信息
                markkey: markkey, // #投放代码
                create_time: new Date().getTime(), // #触发时间
                channel: channel, // #投放渠道
                fromkey: fromkey, // #自定义二级编码
                user_agent: window.navigator.userAgent, // #浏览器访客代理信息
                cookies: document.cookie // #浏览器访客文本信息
            };
            this.msgJson = msgJson;
        },
        clickDownload() {
            const msgJson = Object.assign({}, this.msgJson, {
                sub_action: 'download_click',
                create_time: new Date().getTime()
            });
            this.burialPoint({ topic: 'h5_user_log', msgJson });
            this.download();
        },
        download() {
            if (this.isAndroid) {
                // location.href = this.androidMarketAppLink;
                // setTimeout(() => {
                //     location.href = this.androindLink;
                // }, 2000);
                toApp(this.androidMarketAppLink, this.androindLink);
            } else {
                location.href = this.iosLink;
            }
        },
        clickSelectLang() {
            const self = this;
            const appInfoList = [];

            for (const key in langObj) {
                if (Object.hasOwnProperty.call(langObj, key)) {
                    appInfoList.push({
                        id: key,
                        ...langObj[key],
                        value: languageMap[key]
                    });
                }
            }
            new IosSelect(1, [appInfoList], {
                title: '',
                sureText: this.pageInfo.confirm,
                closeText: this.pageInfo.cancel,
                itemHeight: 50,
                itemShowCount: 5,
                oneLevelId: this.lang,
                showAnimate: true,
                addClassName: 'cust-style',
                callback: function (selectOneObj) {
                    console.log(selectOneObj);
                    self.lang = selectOneObj.id;
                }
            });
        },
        // setLanguage (index) {
        //     this.appInfo = appInfoList[index];
        // },
        setLangFlag() {
            let lang =
                window.navigator.language || window.navigator.userLanguage;
            console.log(`lang: ${lang}`);
            /*
             ** window.navigator.language || window.navigator.userLanguage
             ** 以Chrome为例：
             ** 中文（简体）：zh-CN
             ** 中文（繁体）：zh-TW
             ** 中文（香港）：zh-HK
             ** 中文：zh
             */
            if (lang === 'zh-CN' || lang === 'zh' || lang === 'zh-cn') {
                lang = 'zh-CN';
            }

            this.lang = lang;

            if (!langObj[this.lang]) {
                this.lang = lang.substr(0, 2);
            }
        },
        enterBurialPoint() {
            const msgJson = this.msgJson;
            this.burialPoint({ topic: 'h5_user_log', msgJson });
        },
        getQueryVariable(variable, url) {
            const query = url.match(new RegExp(`[?&]${variable}=([^&]+)`, 'i'));
            if (query == null || query === undefined) {
                return '';
            }
            return query[1];
        },
        burialPoint(burData) {
            let url =
                'https://mp-jp-prod.appsmb.com/mop/v5/app/actions/sendmsgCustom';
            if (this.env === 'sit') {
                url =
                    'https://mp-jp-sit.appsmb.com/mop/v5/app/actions/sendmsgCustom';
            }
            axios({
                url,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                params: burData
            })
                .then(function (response) {
                    console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
};
</script>

<style scoped>
@import url('../assets/css/reset.css');
@import url('../assets/css/iosSelect.css');
html {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-family: sans-serif;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    height: 100%;
    font-family: 'Microsoft YaHei';
}

body {
    margin: 0;
    line-height: 1;
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    height: 100%;
}

a,
button,
a:focus,
button:focus,
a:active,
a:hover {
    outline: 0;
}

a {
    -webkit-user-drag: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-tap-highlight-color: transparent;
}

a[href]:hover {
    cursor: pointer;
}

p {
    margin: 0;
    padding: 0;
}

.bg {
    background-image: url(../assets/image/toshiba/bg@3x.png);
    width: 100%;
    height: 100%;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.bg-pc {
    background-image: url(../assets/image/toshiba/bg_pc@3x.jpg);
    width: 100%;
    height: 100%;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.footer {
    /* position: ;
    bottom: 0.9rem;
    left: 0px; */
    margin-top: 3.3rem;
    width: 100%;
}

.content {
    position: relative;
    height: 100%;
    max-width: 750px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.select-div {
    font-family: SFProText-Regular;
    font-size: 0.32rem;
    color: #ffffff;
    letter-spacing: 0;
    margin-top: 0.48rem;
    position: relative;
}
.select-language {
    font-family: SFProText-Regular;
    font-size: 0.32rem;
    color: #e61e1e;
    letter-spacing: 0;
    line-height: 0.32rem;
}

.select-img-left {
    width: 0.12rem;
    margin-right: 0.08rem;
}
.select-img-right {
    width: 0.12rem;
    margin-left: 0.08rem;
}

.img-wrapper {
    padding: 0px 50px;
    text-align: center;
}

.info-wrapper {
    margin-top: 2.4rem;
    width: 100%;
    text-align: center;
}

.download-wrapper {
    width: 100%;
    text-align: center;
    padding: 0px;
    margin-bottom: 95px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.download-wrapper a {
    background-size: 147px 40px;
    width: 6.3rem;
    font-size: 0.32rem;
    height: 0.96rem;
    margin: 0px auto;
    display: block;
    line-height: 0.96rem;
    text-align: center;
    text-decoration: none;
    background: #267aff;
    border-radius: 0.48rem;
    font-family: SFProText-Medium;
    color: #ffffff;
    letter-spacing: 0;
}

.lan-sheet {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    display: none;
    background: rgba(0, 0, 0, 0.3);
}

.lan-sheet ul {
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 510px;
    background: #ededed;
    position: absolute;
    bottom: 0px;
    left: 0px;
    text-align: center;
    opacity: 1;
}

.lan-sheet li {
    margin: 0px;
    padding: 0px;
    list-style: none;
    background: #fff;
    text-decoration: none;
    text-align: center;
    font-size: 18px;
    color: #333333;
    width: 100%;
    height: 50px;
    line-height: 50px;
    opacity: 1;
    position: relative;
}

.lan-sheet li:not(:last-child):after {
    content: '';
    height: 1px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.12);
    transform: scaleY(0.5);
    -webkit-transform: scaleY(0.5);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
}

.lan-sheet li:last-child {
    margin-top: 10px;
}

.lan-sheet li:last-child img {
    width: 14px;
    clear: both;
    display: block;
    margin: auto;
    padding-top: 18px;
}
#app-introduce {
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif, 'PingFang SC',
        '微软雅黑';
    font-size: 0.4rem;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    font-weight: bold;
    margin-top: 0.48rem;
}
#app-banner {
    /* padding: 12px 0; */
    opacity: 0.6;
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif, 'PingFang SC',
        '微软雅黑';
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
    line-height: 14px;
}
.ios-select-widget-box .layer {
    height: 302px !important;
    background-color: #f2f2f2;
}
.ios-select-widget-box header.iosselect-header {
    position: absolute;
    bottom: 0px;
    background-color: #ffffff;
}
.ios-select-widget-box header.iosselect-header a.close {
    width: 50%;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #666666;
    letter-spacing: 0.3px;
    text-align: center;
    line-height: 24px;
    border-right: solid 0.5px #f2f2f2;
}
.ios-select-widget-box header.iosselect-header a.sure {
    width: 50%;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0.3px;
    text-align: center;
    line-height: 24px;
    border-left: solid 0.5px #f2f2f2;
}
.cover-area1 {
    top: 99px !important;
}
.cover-area2 {
    top: 151px !important;
}
.logo-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
}
.logo {
    display: block;
    width: 1.6rem;
    height: 1.6rem;
}
.remind-text {
    font-family: SFProText-Regular;
    font-size: 0.24rem;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    width: 5.6rem;
    margin-bottom: 0.32rem;
}
.float-left {
    float: left;
}
.app-download {
    background-size: 147px 40px;
    width: 6.3rem;
    font-size: 0.36rem;
    height: 0.96rem;
    margin: 0px auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    background: #e61e1e;
    border-radius: 0.48rem;
    font-family: SFProText-Medium;
    color: #ffffff;
    letter-spacing: 0;
}
.download-icon {
    width: 0.36rem;
    height: 0.36rem;
    margin-right: 0.16rem;
}
</style>
